var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-navbar",
    {
      staticClass: "jh-navbar",
      attrs: { "data-cy": "navbar", toggleable: "md", type: "dark" },
    },
    [
      _c(
        "b-navbar-brand",
        { staticClass: "logo", attrs: { "b-link": "", to: "/" } },
        [
          _c(
            "svg",
            {
              staticClass: "logo",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 440.37 202.28",
                width: "122",
                height: "61",
              },
            },
            [
              _c("path", {
                attrs: {
                  fill: "#ffffff",
                  d: "M421,162.16h-2.21V151.72h-3.95v-2h10.11v2H421v10.44Z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "#ffffff",
                  d: "M434.24,159.1h-.08l-3.89-5.84v8.91h-2.15V149.7h2.33l3.8,5.89L438,149.7h2.34v12.47h-2.19v-8.94Z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "#ffffff",
                  d: "M21.91,202.28c-7.67,0-12.11-1.95-12.11-11.94V161.41l-7.65-.87A2.14,2.14,0,0,1,0,158.41v-2.29A2.11,2.11,0,0,1,2.23,154H9.81v-7.66a2.34,2.34,0,0,1,2-2.3l4.76-.69a2,2,0,0,1,1.88,2V154H27a2.31,2.31,0,0,1,2.31,2.31v2.87A2.31,2.31,0,0,1,27,161.46H18.48v28.86c0,4.34,1,4.7,3.94,4.7h4.73c2,0,2.39,1,2.39,1.8v3c0,.79-.35,1.79-2,2.05A40.19,40.19,0,0,1,21.91,202.28Z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "#ffffff",
                  d: "M57.43,202.28c-7.39,0-19.8-2.72-19.8-20.89v-7.6C37.63,161,44.87,153.4,57,153.4s19.2,7.43,19.2,20.39v4.56A2.23,2.23,0,0,1,74,180.83H46.3v.57c0,9.22,3.33,13.15,11.12,13.15a115.74,115.74,0,0,0,14.94-.92h.51a1.79,1.79,0,0,1,2,1.8v2.87a2.29,2.29,0,0,1-2.19,2.55A77.82,77.82,0,0,1,57.43,202.28ZM46.31,173.92H67.46v-.14c0-8.86-3.12-12.64-10.45-12.64s-10.7,4.14-10.7,12.64Z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "#ffffff",
                  d: "M97.14,201.68H92.75a2.23,2.23,0,0,1-2.14-2.31V139.14a2.16,2.16,0,0,1,2.14-2.23h4.39a2.16,2.16,0,0,1,2.14,2.23v60.23A2.2,2.2,0,0,1,97.14,201.68Z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "#ffffff",
                  d: "M122.41,201.68H118a2.23,2.23,0,0,1-2.14-2.31V139.14a2.16,2.16,0,0,1,2.14-2.23h4.4a2.16,2.16,0,0,1,2.14,2.23v60.23A2.24,2.24,0,0,1,122.41,201.68Z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "#ffffff",
                  d: "M195.15,201.68h-4.06a2.32,2.32,0,0,1-2.31-2.31V169.46c0-7.46-3.78-8.42-7.07-8.42a27.5,27.5,0,0,0-9.15,2,26.83,26.83,0,0,1,.64,6.21v30.07a2.21,2.21,0,0,1-2.14,2.31h-4.48a2.14,2.14,0,0,1-2.05-2.31V169.3c0-7-1.9-8.25-5.89-8.25-3.08,0-6.93,1.7-9.69,3.06v35.26a2.21,2.21,0,0,1-2.14,2.31h-4.48a2.14,2.14,0,0,1-2.05-2.31V156.29A2.25,2.25,0,0,1,142.5,154h4.22a2.24,2.24,0,0,1,2.23,2.31v.51a23.42,23.42,0,0,1,11.71-3.5c3.73,0,6.48,1.06,8.6,3.33a34.26,34.26,0,0,1,13.87-3.33c6.53,0,14.3,2.8,14.3,16.16v29.91A2.27,2.27,0,0,1,195.15,201.68Z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "#ffffff",
                  d: "M230.63,202.28c-7.4,0-19.8-2.72-19.8-20.89v-7.6c0-12.77,7.24-20.39,19.37-20.39s19.2,7.43,19.2,20.39v4.56a2.23,2.23,0,0,1-2.22,2.48H219.5v.57c0,9.22,3.33,13.15,11.13,13.15a115.74,115.74,0,0,0,14.94-.92h.51a1.81,1.81,0,0,1,2,1.8v2.87a2.29,2.29,0,0,1-2.19,2.55A78,78,0,0,1,230.63,202.28Zm-11.12-28.36h21.15v-.14c0-8.86-3.12-12.64-10.45-12.64s-10.7,4.14-10.7,12.64Z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "#ffffff",
                  d: "M284.62,202.28c-10.88,0-22.5-7.06-22.5-26.89V164.07c0-24.34,16.27-27,23.26-27a99.21,99.21,0,0,1,16.15,1.19c1.22.14,2,.84,2,1.88v4.23c0,.55-.23,1.46-1.72,1.46h-.34c-5.33-.45-9.21-.59-16.05-.59-9.51,0-14.33,6.33-14.33,18.81V175.4c0,12.13,4.82,18.81,13.57,18.81,4.67,0,7.89-.28,10-.46V170.16a2.18,2.18,0,0,1,2.14-2.31h4.56a2.3,2.3,0,0,1,2.23,2.31v28.39a2.44,2.44,0,0,1-2,2.47A100.14,100.14,0,0,1,284.62,202.28Z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "#ffffff",
                  d: "M336,202.28c-7.39,0-19.8-2.72-19.8-20.89v-7.6c0-12.77,7.24-20.39,19.37-20.39s19.2,7.43,19.2,20.39v4.56a2.23,2.23,0,0,1-2.22,2.48H324.82v.57c0,9.22,3.33,13.15,11.12,13.15a116,116,0,0,0,14.95-.92h.51a1.81,1.81,0,0,1,2,1.8v2.87a2.29,2.29,0,0,1-2.19,2.55A78.07,78.07,0,0,1,336,202.28Zm-11.13-28.36H346v-.14c0-8.86-3.12-12.64-10.45-12.64s-10.7,4.14-10.7,12.64Z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "#ffffff",
                  d: "M401.13,201.68h-4.05a2.31,2.31,0,0,1-2.31-2.31V171.58c0-8.81-3.18-10.53-8.67-10.53-3,0-6.65,1-10.79,3.06v35.26a2.37,2.37,0,0,1-2.31,2.31h-4.14a2.3,2.3,0,0,1-2.22-2.31V156.29a2.25,2.25,0,0,1,2.22-2.31h4.22a2.24,2.24,0,0,1,2.23,2.31v.56a25.18,25.18,0,0,1,12.81-3.46c10.16,0,15.32,6.12,15.32,18.19v27.79A2.32,2.32,0,0,1,401.13,201.68Z",
                },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  fill: "#d5e9df",
                  x: "144.21",
                  y: "23",
                  width: "23.01",
                  height: "23",
                },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  fill: "#e55e62",
                  x: "167.22",
                  y: "23",
                  width: "22.99",
                  height: "23",
                },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  fill: "#5c493c",
                  x: "167.22",
                  y: "46",
                  width: "22.99",
                  height: "23",
                },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  fill: "#71bfb9",
                  x: "144.21",
                  y: "46",
                  width: "23.01",
                  height: "23",
                },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  fill: "#98c368",
                  x: "167.22",
                  y: "69.01",
                  width: "22.99",
                  height: "23",
                },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  fill: "#fbce59",
                  x: "190.21",
                  y: "46",
                  width: "23.01",
                  height: "23",
                },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  fill: "#ef9b66",
                  x: "213.22",
                  y: "46",
                  width: "23.01",
                  height: "23",
                },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  fill: "#4b5c9f",
                  x: "190.21",
                  y: "69.01",
                  width: "23.01",
                  height: "23",
                },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  fill: "#82c7cf",
                  x: "213.22",
                  y: "69.01",
                  width: "23.01",
                  height: "23",
                },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  fill: "#79aad4",
                  x: "190.21",
                  y: "92.01",
                  width: "23.01",
                  height: "23",
                },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  fill: "#2fb6e3",
                  x: "190.21",
                  y: "23",
                  width: "23.01",
                  height: "23",
                },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  fill: "#474a52",
                  x: "213.22",
                  y: "23",
                  width: "23.01",
                  height: "23",
                },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  fill: "#eb8fad",
                  x: "213.22",
                  width: "23.01",
                  height: "23",
                },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  fill: "#d9d1c4",
                  x: "236.23",
                  y: "23",
                  width: "22.99",
                  height: "23",
                },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  fill: "#dce169",
                  x: "167.22",
                  width: "22.99",
                  height: "23",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "navbar-title" }, [_vm._v("Translations")]),
          _vm._v(" "),
          _c("span", { staticClass: "navbar-version" }, [
            _vm._v(_vm._s(_vm.version)),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-navbar-toggle",
        {
          staticClass: "jh-navbar-toggler d-lg-none",
          attrs: {
            right: "",
            href: "javascript:void(0);",
            "data-toggle": "collapse",
            target: "header-tabs",
            "aria-expanded": "false",
            "aria-label": "Toggle navigation",
          },
        },
        [_c("font-awesome-icon", { attrs: { icon: "bars" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-collapse",
        { attrs: { "is-nav": "", id: "header-tabs" } },
        [
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c("b-nav-item", { attrs: { to: "/", exact: "" } }, [
                _c(
                  "span",
                  [
                    _c("font-awesome-icon", { attrs: { icon: "home" } }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Home")]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _vm.authenticated
                ? _c(
                    "b-nav-item-dropdown",
                    {
                      staticClass: "pointer",
                      attrs: {
                        right: "",
                        id: "menu",
                        "active-class": "active",
                        "data-cy": "entity",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "navbar-dropdown-menu",
                          attrs: { slot: "button-content" },
                          slot: "button-content",
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "th-list" },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "no-bold" }, [
                            _vm._v("Menu"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "b-dropdown-item",
                            { attrs: { to: "/projects-menu" } },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "asterisk" },
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("Proyectos")]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.authenticated && _vm.hasAnyAuthority("ROLE_ADMIN")
                ? _c(
                    "b-nav-item-dropdown",
                    {
                      staticClass: "pointer",
                      attrs: {
                        right: "",
                        id: "entity-menu",
                        "active-class": "active",
                        "data-cy": "entity",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "navbar-dropdown-menu",
                          attrs: { slot: "button-content" },
                          slot: "button-content",
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "th-list" },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "no-bold" }, [
                            _vm._v("Entities"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("entities-menu"),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasAnyAuthority("ROLE_ADMIN") && _vm.authenticated
                ? _c(
                    "b-nav-item-dropdown",
                    {
                      staticClass: "pointer",
                      class: {
                        "router-link-active": _vm.subIsActive("/admin"),
                      },
                      attrs: {
                        right: "",
                        id: "admin-menu",
                        "active-class": "active",
                        "data-cy": "adminMenu",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "navbar-dropdown-menu",
                          attrs: { slot: "button-content" },
                          slot: "button-content",
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "users-cog" },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "no-bold" }, [
                            _vm._v("Administration"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: "/admin/user-management",
                            "active-class": "active",
                          },
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "users" } }),
                          _vm._v(" "),
                          _c("span", [_vm._v("User management")]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: "/admin/metrics",
                            "active-class": "active",
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "tachometer-alt" },
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Metrics")]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: "/admin/health",
                            "active-class": "active",
                          },
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "heart" } }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Health")]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: "/admin/configuration",
                            "active-class": "active",
                          },
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "cogs" } }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Configuration")]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: "/admin/logs",
                            "active-class": "active",
                          },
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "tasks" } }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Logs")]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.openAPIEnabled
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: {
                                to: "/admin/docs",
                                "active-class": "active",
                              },
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "book" },
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("API")]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-nav-item-dropdown",
                {
                  staticClass: "pointer",
                  class: { "router-link-active": _vm.subIsActive("/account") },
                  attrs: {
                    right: "",
                    href: "javascript:void(0);",
                    id: "account-menu",
                    "active-class": "active",
                    "data-cy": "accountMenu",
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "navbar-dropdown-menu",
                      attrs: { slot: "button-content" },
                      slot: "button-content",
                    },
                    [
                      _c("font-awesome-icon", { attrs: { icon: "user" } }),
                      _vm._v(" "),
                      _c("span", { staticClass: "no-bold" }, [
                        _vm._v(" Account "),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.authenticated
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            "data-cy": "settings",
                            to: "/account/settings",
                            tag: "b-dropdown-item",
                            "active-class": "active",
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "wrench" },
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Settings")]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.authenticated
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            "data-cy": "passwordItem",
                            to: "/account/password",
                            tag: "b-dropdown-item",
                            "active-class": "active",
                          },
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "lock" } }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Password")]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.authenticated
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            "data-cy": "logout",
                            id: "logout",
                            "active-class": "active",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.logout()
                            },
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "sign-out-alt" },
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Sign out")]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.authenticated
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            "data-cy": "login",
                            id: "login",
                            "active-class": "active",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.openLogin()
                            },
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "sign-in-alt" },
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Sign in")]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.authenticated
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            "data-cy": "register",
                            to: "/register",
                            tag: "b-dropdown-item",
                            id: "register",
                            "active-class": "active",
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "user-plus" },
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Register")]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }